import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { fillRule: "evenodd", d: "M22.167 13.333a7.833 7.833 0 11-15.667 0 7.833 7.833 0 0115.667 0zm-2.568 7.708a9.333 9.333 0 111.168-.945l6.121 6.733-1.11 1.009L19.6 21.04z" }));
export {
  a as ReactComponent
};
